<template>
  <div id="app">
    <Navbar></Navbar>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  }
}
</script>

<style>
  @import url('../static/css/animate.css');
  @import url('../static/css/icomoon.css');
  @import url('../static/css/themify-icons.css');
  @import url('../static/css/bootstrap.css');
  @import url('../static/css/magnific-popup.css');
  @import url('../static/css/style.css');
  @import url('../static/css/custom.css');
</style>



// WEBPACK FOOTER //
// src/App.vue